const APP_CONFIG = {
  FRONTEND_VERSION: 49,
  CLIENT_PLATFORM: "web",
};

export default APP_CONFIG;
